var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#55ACEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1ED761"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.099 25.35L8.333 31.77l6.594-1.722a12.49 12.49 0 005.958 1.507c5.633 0 10.564-3.767 12.022-9.183 1.459-5.417-.918-11.134-5.796-13.94a12.49 12.49 0 00-15.025 1.963A12.351 12.351 0 0010.1 25.35zm5.516 2.677l-.374-.224-3.925 1.022 1.047-3.799-.246-.39a10.263 10.263 0 011.25-12.55 10.378 10.378 0 0112.52-1.934 10.28 10.28 0 015.009 11.585c-1.179 4.547-5.298 7.725-10.015 7.725a10.37 10.37 0 01-5.266-1.435z",
    fill: "url(#whatsapp_svg__paint0_linear_1_15490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.768 13.947c-.233-.52-.478-.524-.7-.534-.18-.004-.389-.004-.595-.004-.319.008-.62.148-.83.386-.284.311-1.087 1.054-1.087 2.57 0 1.517 1.114 2.983 1.269 3.188.154.206 2.15 3.417 5.31 4.653 2.625 1.027 3.16.823 3.73.772.57-.051 1.838-.746 2.097-1.466.258-.72.259-1.336.181-1.466-.077-.13-.285-.207-.596-.359-.31-.151-1.839-.9-2.123-1.003-.285-.103-.493-.154-.7.155-.207.308-.802 1.002-.983 1.207-.181.206-.363.233-.674.078-.31-.155-1.311-.48-2.5-1.53a9.325 9.325 0 01-1.729-2.134c-.18-.311-.019-.475.137-.629.14-.139.314-.36.466-.54.13-.157.235-.332.313-.519a.565.565 0 00-.025-.54c-.081-.152-.685-1.677-.961-2.285z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp_svg__paint0_linear_1_15490",
    x1: 33.332,
    y1: 31.769,
    x2: 33.332,
    y2: 6.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
export default SvgWhatsapp;